import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from '../asset/img/logo.svg';
import navIcon1 from '../asset/img/nav-icon1.svg';
import navIcon2 from '../asset/img/nav-icon2.svg';
import navIcon3 from '../asset/img/nav-icon3.svg';
import { HashLink } from 'react-router-hash-link';

export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);
    const [toggleOn, setToggleOn] = useState(false);
    const [isAutoMode, setIsAutoMode] = useState(true);
    const [expanded, setExpanded] = useState(false);

    // Function to check if it's daytime based on the current time
    const isDaytime = () => {
      const now = new Date();
      const hours = now.getHours();
      // Simple approximation: daytime is between 6 AM and 6 PM
      return hours >= 6 && hours < 18;
    };

    useEffect(() => {
      const onScroll = () => {
        if (window.scrollY > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      }
      window.addEventListener("scroll", onScroll);

      return () => window.removeEventListener("scroll", onScroll);
    }, [])
  
    // Initialize theme based on time of day when auto mode is active
    useEffect(() => {
      if (isAutoMode) {
        // In auto mode, dark theme (toggleOn = true) when it's nighttime
        setToggleOn(!isDaytime());
      }
    }, [isAutoMode]);

    // Check time and update theme periodically when in auto mode
    useEffect(() => {
      if (!isAutoMode) return;
      
      // Set up interval to check every minute
      const intervalId = setInterval(() => {
        if (isAutoMode) {
          setToggleOn(!isDaytime());
        }
      }, 60000); // Check every minute
      
      return () => clearInterval(intervalId);
    }, [isAutoMode]);

    // Apply theme to body based on toggle state
    useEffect(() => {
      if (toggleOn) {
        document.body.classList.remove('white-mode');
        document.body.classList.add('dark-mode');
      } else {
        document.body.classList.remove('dark-mode');
        document.body.classList.add('white-mode');
      }
    }, [toggleOn]);

    const onUpdateActiveLink = (value) => {
      setActiveLink(value);
      setExpanded(false); // Close mobile menu when a link is clicked
    };

    const handleToggle = () => {
      if (isAutoMode) {
        setIsAutoMode(false); // Exit auto mode when manually toggling
      }
      setToggleOn(prevToggle => !prevToggle);
    };

    return (
      <Navbar 
        expand="md" 
        className={scrolled ? "scrolled" : ""} 
        expanded={expanded}
        onToggle={(expanded) => setExpanded(expanded)}
      >
        <Container>
          <Navbar.Brand href="/">
            <img src={logo} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>home</Nav.Link>
              <Nav.Link href="#about" className={activeLink === 'about' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('about')}>about</Nav.Link>
              <Nav.Link href="#education" className={activeLink === 'education' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('education')}>education</Nav.Link>
              <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>skills</Nav.Link>
              <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>projects</Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href="https://www.linkedin.com/in/khaihuyennn/" target="_blank" rel="noreferrer"><img src={navIcon1} alt="LinkedIn" /></a>
                <a href="https://github.com/khaihuyenn" target="_blank" rel="noreferrer"><img src={navIcon2} alt="GitHub" /></a>
                <a href="https://www.instagram.com/khnguyeenx/" target="_blank" rel="noreferrer"><img src={navIcon3} alt="Instagram" /></a>
              </div>
              <HashLink to='#connect'>
                <button className="vvd"><span>Connect</span></button>
              </HashLink>
              <div className="toggle-switch" onClick={handleToggle}>
                  <input type="checkbox" checked={toggleOn} readOnly />
                  <span className="slider">
                  <span className="icon sun">☀️</span>
                  <span className="icon moon">🌙</span>
                  </span>
              </div>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    )
}